// @module C3.ShoppingExtensions.System8Page
define('C3.ShoppingExtensions.MeetTeam.Bio.View'
,	[
	    'c3_shoppingextensions_meetourteam_bio.tpl'
	,	'SCView'
	,   'Utils'

    ]
, function (
	    c3_shoppingextensions_meetourteam_bio_tpl
	,	SCViewModule
	,   Utils
)
{
    'use strict';

     var SCView = SCViewModule.SCView;

     function MeetTeamBioView (options) {
     	SCView.call(this, options);

     	  this.template = c3_shoppingextensions_meetourteam_bio_tpl;
            this.options = options;
		  this.application = options.application;
            this.modalClass = "Meet-Team"
     }

     MeetTeamBioView.prototype = Object.create(SCView.prototype);
     MeetTeamBioView.prototype.constructor = MeetTeamBioView;

     MeetTeamBioView.prototype.render = function () {
    	SCView.prototype.render.call(this);
    	
    }

    MeetTeamBioView.prototype.getContext = function () {
    	return {
    	 userName : this.options.name,
         userTitle : this.options.title,
         userImg : this.options.empImg,
         userBio : this.options.empBio		
    	}
    }

     return MeetTeamBioView;
});
